import { createAsyncThunk } from '@reduxjs/toolkit';
import employeeServiceApiInstance from '../../../../config/employeeApiConfig';



export const createleaveEncashment = createAsyncThunk(
  'leaveEncashment/crete',
  async ({data } : { data: Partial<any> }, { rejectWithValue }) => {
    try {
      const response = await employeeServiceApiInstance.post(`/leaveencashment/encashment`, data);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to create Leave Encashment');
    }
  }
);
export const fetchAllleave_Encashment = createAsyncThunk(
  'leaveEncashment/fetchall',
   async (_, { rejectWithValue }) => {
    try {
      const response = await employeeServiceApiInstance.get(`/leaveencashment/encashment`);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to create Leave Encashment');
    }
  }
);
export const fetchAllleave_EncashmentBYEmployeeId = createAsyncThunk(
  'leaveEncashment/employeeId',
   async ( employeeId : any, { rejectWithValue }) => {
    try {
      const response = await employeeServiceApiInstance.get(`/leaveencashment/encashment/${employeeId}`);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to fetch Leave Encashment By Id');
    }
  }
);
export const UpdateEncashment = createAsyncThunk(
  'leaveEncashment/update',
   async ( {Id , data} : any, { rejectWithValue }) => {
    try {
      const response = await employeeServiceApiInstance.put(`/leaveencashment/encashment/${Id}`,data);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to fetch Leave Encashment By Id');
    }
  }
);
export const UpdateEncashmentByHr = createAsyncThunk(
  'leaveEncashment/update',
  async ({ employeeId, leavetype, status }: any, { rejectWithValue }) => {
    try {
      const response = await employeeServiceApiInstance.put(
        `/leaveencashment/encashment/hr/update?employeeId=${employeeId}&leavetype=${leavetype}&status=${status}`
      );
      return response.data;
    } catch (error: any) {
      return rejectWithValue(
        error.response?.data || 'Failed to fetch Leave Encashment By Id'
      );
    }
  }
);
export const fetchLeaveEncashmentBySupervisorHierarchy = createAsyncThunk(
  "leaveEncashment/fetchLeaveEncashmentBySupervisorHierarchy",
  async (
    { supervisorId, includeSelf = false }: { supervisorId: number; includeSelf?: boolean },
    { rejectWithValue }
  ) => {
    try {
      const response = await employeeServiceApiInstance.get(
        `/leaveencashment/supervisor/${supervisorId}`,
        { params: { includeSelf } }
      );
      return response.data;
    } catch (error: any) {
      return rejectWithValue(
        error.response?.data || "Failed to fetch supervisor hierarchy leave encashments"
      );
    }
  }
);